const preferencesButton = document.getElementById(
  "usercentrics-preferences-button"
);

if (preferencesButton) {
  preferencesButton.addEventListener("click", function () {

    if (window.UC_UI?.showSecondLayer) {
      window.UC_UI.showSecondLayer();
    }
  });
}